import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "clinicarx-buttons" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "cares-info open-sans-font" }, " Gostaria de falar com um médico? ", -1)
const _hoisted_3 = { class: "button-custom" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "open-sans-font" }, "Realizar consulta médica", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "button-container",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openLink(_ctx.link)))
    }, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", { src: _ctx.stethoscopeIconPath }, null, 8, _hoisted_4),
        _hoisted_5
      ])
    ])
  ]))
}